<div class="container-fluid">
  <h2 class="mb-1">{{'HELP.TITLE' | translate}}</h2>
  <p class="help-lede">{{'HELP.LEDE' | translate}}</p>

  <!--
    The search box is the first thing on the page because the reader usually
    arrives with a question, not with an intention to read all of it. Every
    card is shown underneath by default, so an empty box is a browsable page
    rather than a prompt.
  -->
  <div class="help-search">
    <lucide-icon name="funnel" size="16" class="help-search-icon"></lucide-icon>
    <input type="search" class="form-control" id="helpSearch" name="helpSearch"
           [(ngModel)]="search" (ngModelChange)="applySearch()"
           [attr.placeholder]="'HELP.SEARCH_PLACEHOLDER' | translate"
           [attr.aria-label]="'HELP.SEARCH_PLACEHOLDER' | translate">
    @if (search) {
      <button type="button" class="btn btn-link help-search-clear" (click)="clearSearch()">
        {{'HELP.CLEAR' | translate}}
      </button>
    }
  </div>

  @if (search) {
    <p class="help-count">{{'HELP.RESULT_COUNT' | translate:{ count: visible.length } }}</p>
  }

  @if (visible.length === 0) {
    <div class="help-empty">
      <p class="mb-1">{{'HELP.NO_RESULTS' | translate}}</p>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearSearch()">
        {{'HELP.SHOW_ALL' | translate}}
      </button>
    </div>
  }

  @for (category of categories; track category) {
    @if (cardsIn(category).length) {
      <section class="help-section">
        <h3 class="help-section-title">{{('HELP.CATEGORY.' + (category | uppercase)) | translate}}</h3>
        <div class="help-grid">
          @for (card of cardsIn(category); track card.id) {
            <article class="help-card" [id]="card.id">
              <div class="help-card-head">
                <lucide-icon [name]="card.icon" size="18" class="help-card-icon"></lucide-icon>
                <h4 class="help-card-title">{{text(card.title)}}</h4>
              </div>
              <p class="help-card-body">{{text(card.body)}}</p>
            </article>
          }
        </div>
      </section>
    }
  }

  <!--
    Whatever the deployment wrote in the old rich-text editor, kept. Only shown
    when it holds something, and only when the reader is not searching -- it is
    free text, so it cannot take part in a card search honestly.
  -->
  @if (helpContent && !search) {
    <section class="help-section">
      <h3 class="help-section-title">{{'HELP.ADDITIONAL' | translate}}</h3>
      <div class="help-legacy" (click)="onContentClick($event)">
        <div [innerHTML]="helpContent"></div>
      </div>
    </section>
  }
</div>
